import {
  FaGlobe,
  FaChartLine,
  FaFileInvoiceDollar,
  FaChartPie,
  FaCalculator,
  FaFileSignature,
  FaRocket,
  FaLightbulb,
  FaLeaf,
  FaUserTie,
} from "react-icons/fa";
import img1 from "../../images/service/stopic/market.png";
import img2 from "../../images/service/stopic/audit.png";
import img3 from "../../images/service/stopic/tax.png";
import img4 from "../../images/service/stopic/valuation.png";
import img5 from "../../images/service/stopic/Accounting.png";
import img6 from "../../images/service/stopic/compliance.png";
import img7 from "../../images/service/stopic/ipo.png";
import img8 from "../../images/service/stopic/consulting.png";
import img9 from "../../images/service/stopic/esg.png";
import img10 from "../../images/service/stopic/virtual.png";

// Sub-topic images
import indiaEntryImg from "../../images/service/subHeadings/India Entry & Entity Structuring.png";
import femaImg from "../../images/service/subHeadings/FEMA & Cross-Border Advisory.png";
import businessRegistrationsImg from "../../images/service/subHeadings/Business Registrations, Approvals & Licenses.png";
import statutoryAuditsImg from "../../images/service/subHeadings/Statutory, Tax & Internal Audits.png";
import managementAuditsImg from "../../images/service/subHeadings/Management & Operational Audits.png";
import ifcDesignImg from "../../images/service/subHeadings/IFC Design & Risk Review.png";
import complianceProcessImg from "../../images/service/subHeadings/Compliance & Process Assessment.png";
import directIndirectTaxImg from "../../images/service/subHeadings/Direct & Indirect Tax Advisory.png";
import gstComplianceImg from "../../images/service/subHeadings/GST Compliance & Litigation Support.png";
import internationalTaxImg from "../../images/service/subHeadings/International Taxation.png";
import taxStructuringImg from "../../images/service/subHeadings/Tax Structuring & Optimization.png";
import outsourcedBookkeepingImg from "../../images/service/subHeadings/Outsourced Bookkeeping.png";
import misReportingImg from "../../images/service/subHeadings/MIS & Management Reporting.png";
import financeAutomationImg from "../../images/service/subHeadings/Finance Process Automation.png";
import managedPayrollImg from "../../images/service/subHeadings/Managed Payroll & People Compliance.png";
import ifrsIndAsImg from "../../images/service/subHeadings/IFRS : Ind-AS Accounting Support.png";
import corporateLawImg from "../../images/service/subHeadings/Corporate Law & Secretarial Advisory.png";
import rocFilingsImg from "../../images/service/subHeadings/ROC Filings & Statutory Registers Management.png";
import boardGovernanceImg from "../../images/service/subHeadings/Board & Shareholder Governance Support.png";
import femaRbiComplianceImg from "../../images/service/subHeadings/FEMA : RBI Compliance.png";

// Category 2 & 3: Advisory & Deals / IPO
import ipoReadinessImg from "../../images/service/subHeadings/IPO Readiness Assessment.png";
import financialRestatementImg from "../../images/service/subHeadings/Financial Statement Restatement & Audit Support.png";
import internalControlsSetupImg from "../../images/service/subHeadings/Internal Controls & Corporate Governance.png";
import merchantBankerCoordinationImg from "../../images/service/subHeadings/Coordination with Merchant Bankers & Legal Advisors.png";
import independentCACertImg from "../../images/service/subHeadings/Independent Chartered Accountant Certification Services.png";
import maSupportImg from "../../images/service/subHeadings/Mergers & Acquisitions (M&A) Support.png";
import businessValuationImg from "../../images/service/subHeadings/Business Valuation & Financial Modelling.png";
import fundraisingImg from "../../images/service/subHeadings/Fundraising & Deal Structuring.png";
import postMergerImg from "../../images/service/subHeadings/Post-Merger Integration Assistance.png";

// Category 4: Management Consulting
import strategyTransformationImg from "../../images/service/subHeadings/Business Strategy & Transformation.png";
import performanceImprovementImg from "../../images/service/subHeadings/Performance Improvement & Cost Optimisation.png";
import riskManagementImg from "../../images/service/subHeadings/Risk Management & Internal Controls.png";
import digitalTransformationImg from "../../images/service/subHeadings/Digital Transformation Advisory.png";

// Category 5: ESG
import esgReportingImg from "../../images/service/subHeadings/ESG Reporting & Disclosures.png";
import sustainabilityStrategyImg from "../../images/service/subHeadings/Sustainability Strategy & Carbon Footprint.png";
import csrAdvisoryImg from "../../images/service/subHeadings/CSR Compliance Advisory.png";

// Category 6: Virtual CFO
import strategicFinanceImg from "../../images/service/subHeadings/Strategic Financial Leadership.png";
import businessPerformanceImg from "../../images/service/subHeadings/Business Performance Review.png";
import capitalAllocationImg from "../../images/service/subHeadings/Capital Allocation & Cash-Flow Planning.png";
import investorReportingImg from "../../images/service/subHeadings/Investor & Lender Reporting.png";
import boardLevelAdvisoryImg from "../../images/service/subHeadings/Board-Level Financial Advisory.png";

// Mapping of sub-topic names to their images
export const subTopicImages = {
  // Set Up Your Business in India
  "India Entry & Entity Structuring": indiaEntryImg,
  "FEMA & Cross-Border Advisory": femaImg,
  "Business Registrations, Approvals & Licenses": businessRegistrationsImg,
  // Audit & Assurance
  "Statutory, Tax & Internal Audits": statutoryAuditsImg,
  "Management & Operational Audits": managementAuditsImg,
  "IFC Design & Risk Review": ifcDesignImg,
  "Compliance & Process Assessments": complianceProcessImg,
  // Taxation & Regulatory
  "Direct & Indirect Tax Advisory": directIndirectTaxImg,
  "GST Compliance & Litigation Support": gstComplianceImg,
  "International Taxation & Transfer Pricing": internationalTaxImg,
  "Tax Structuring & Optimization": taxStructuringImg,
  // Accounting & Business Support
  "Outsourced Bookkeeping": outsourcedBookkeepingImg,
  "MIS & Management Reporting": misReportingImg,
  "Financial Process Automation": financeAutomationImg,
  "Managed Payroll & People Compliance": managedPayrollImg,
  "IFRS / Ind-AS Accounting Support": ifrsIndAsImg,
  // Corporate Secretarial & Governance
  "Corporate Law & Secretarial Advisory": corporateLawImg,
  "ROC Filings & Statutory Registers": rocFilingsImg,
  "Board & Shareholder Governance Support": boardGovernanceImg,
  "FEMA/RBI Compliance for Foreign-Owned Entities": femaRbiComplianceImg,
  // IPO Advisory & Capital Markets Readiness
  "IPO Readiness Assessment": ipoReadinessImg,
  "Financial Statement Restatement & Audit Support": financialRestatementImg,
  "Internal Controls & Corporate Governance Setup": internalControlsSetupImg,
  "Coordination with Merchant Bankers & Legal Advisors":
    merchantBankerCoordinationImg,
  "Independent Chartered Accountant Certification Services":
    independentCACertImg,
  // Advisory & Deals
  "M&A Support & Due Diligence": maSupportImg,
  "Business Valuation & Financial Modeling": businessValuationImg,
  "Fundraising & Deal Structuring": fundraisingImg,
  "Post-Merger Integration Assistance": postMergerImg,
  // Management Consulting & Business Transformation
  "Business Strategy & Transformation": strategyTransformationImg,
  "Performance Improvement & Cost Optimization": performanceImprovementImg,
  "Risk Management & Internal Controls": riskManagementImg,
  "Digital Transformation Advisory": digitalTransformationImg,
  // ESG & Sustainability Consulting
  "ESG Reporting & Disclosures": esgReportingImg,
  "Sustainability Strategy & Carbon Footprint Analysis":
    sustainabilityStrategyImg,
  "CSR Compliance Advisory": csrAdvisoryImg,
  // Virtual CFO Services
  "Strategic Financial Leadership": strategicFinanceImg,
  "Business Performance Review": businessPerformanceImg,
  "Capital Allocation & Cash-Flow Planning": capitalAllocationImg,
  "Investor & Lender Reporting": investorReportingImg,
  "Board-Level Financial Advisory": boardLevelAdvisoryImg,
};

const servicesData = [
  {
    Id: "1",
    category: "Business Setup & Compliance",
    icon: <FaGlobe />,
    image: img1,
    sTitle: "Set Up Your Business in India",
    sub1: "India Entry & Entity Structuring",
    sub2: "FEMA & Cross-Border Advisory",
    sub3: "Business Registrations, Approvals & Licenses",
  },
  {
    Id: "2",
    category: "Business Setup & Compliance",
    icon: <FaChartLine />,
    image: img2,
    sTitle: "Audit & Assurance",
    sub1: "Statutory, Tax & Internal Audits",
    sub2: "Management & Operational Audits",
    sub3: "IFC Design & Risk Review",
    sub4: "Compliance & Process Assessments",
  },
  {
    Id: "3",
    category: "Business Setup & Compliance",
    image: img3,
    icon: <FaFileInvoiceDollar />,
    sTitle: "Taxation & Regulatory",
    intro:
      "Comprehensive tax advisory and compliance support for businesses operating in India",
    description: [
      "India's tax environment is dynamic and constantly evolving, with frequent regulatory changes, complex compliance requirements and increased scrutiny from tax authorities. Businesses operating in India — whether domestic or multinational — need structured tax planning and disciplined compliance to avoid risks, penalties and financial exposure.",
      "At V DOOGAR AND ASSOCIATES, we provide end-to-end tax advisory, compliance, structuring and litigation support across direct and indirect taxes. Our goal is to help you remain fully compliant while optimising your tax position — in line with applicable Indian laws and global tax consideration",
    ],
    sub1: "Direct & Indirect Tax Advisory",
    sub2: "GST Compliance & Litigation Support",
    sub3: "International Taxation & Transfer Pricing",
    sub4: "Tax Structuring & Optimization",
  },
  {
    Id: "4",
    category: "Business Setup & Compliance",
    icon: <FaCalculator />,
    image: img5,
    sTitle: "Accounting & Business Support (Your Finance Back-Office)",
    sub1: "Outsourced Bookkeeping",
    sub2: "MIS & Management Reporting",
    sub3: "Financial Process Automation",
    sub4: "Managed Payroll & People Compliance",
    sub5: "IFRS / Ind-AS Accounting Support",
  },
  {
    Id: "5",
    category: "Corporate Secretarial & Governance",
    icon: <FaFileSignature />,
    image: img6,
    sTitle: "Corporate Secretarial & Governance",
    intro:
      "Ensuring your company remains legally compliant, well-documented and Board-governed at all times.",
    description: [
      "Every company in India must comply with a wide range of corporate laws and regulatory requirements. From ROC filings and statutory registers to FEMA compliance and Board governance — maintaining the right discipline is essential for credibility, investor confidence and legal safety.",
      "At V DOOGAR AND ASSOCIATES, we support Indian and foreign-owned companies in managing all corporate secretarial and governance requirements — accurately, timely and fully compliant with Indian regulations.",
      "Our role is to ensure your company remains legally compliant, well-documented and Board-governed — at all times.",
    ],
    sub1: "Corporate Law & Secretarial Advisory",
    sub2: "ROC Filings & Statutory Registers",
    sub3: "Board & Shareholder Governance Support",
    sub4: "FEMA/RBI Compliance for Foreign-Owned Entities",
  },

  // Category 2: Advisory & Deals
  {
    Id: "6",
    category: "IPO Advisory & Capital Markets Readiness",
    icon: <FaRocket />,
    image: img7,
    sTitle: "IPO Advisory & Capital Markets Readiness",
    sub1: "IPO Readiness Assessment",
    sub2: "Financial Statement Restatement & Audit Support",
    sub3: "Internal Controls & Corporate Governance Setup",
    sub4: "Coordination with Merchant Bankers & Legal Advisors",
    sub5: "Independent Chartered Accountant Certification Services",
  },
  {
    Id: "7",
    category: "Advisory & Deals",
    icon: <FaChartPie />,
    image: img4,
    sTitle: "Transaction Advisory, Due Diligence & Valuations",
    sub1: "M&A Support & Due Diligence",
    sub2: "Business Valuation & Financial Modeling",
    sub3: "Fundraising & Deal Structuring",
    sub4: "Post-Merger Integration Assistance",
  },
  {
    Id: "8",
    category: "Advisory & Deals",
    icon: <FaLightbulb />,
    image: img8,
    sTitle: "Management Consulting & Business Transformation",
    intro:
      "Improving business performance, strengthening governance and building future-ready organisations",
    sub1: "Business Strategy & Transformation",
    sub2: "Performance Improvement & Cost Optimization",
    sub3: "Risk Management & Internal Controls",
    sub4: "Digital Transformation Advisory",
  },
  {
    Id: "9",
    category: "Advisory & Deals",
    icon: <FaLeaf />,
    image: img9,
    sTitle: "ESG & Sustainability Consulting",
    intro:
      "Supporting organisations in building responsible, compliant and trusted businesses",
    description: [
      "Environmental, Social and Governance (ESG) performance is becoming a key indicator of corporate trust and long-term value. Investors, regulators, lenders, customers and employees increasingly expect organisations to demonstrate responsible business practices, transparent reporting and strong governance discipline.",
      "At V DOOGAR AND ASSOCIATES, our ESG & Sustainability Consulting practice helps companies design, implement and report ESG initiatives in a structured, compliant and practical manner. We ensure that ESG is not just a reporting exercise — but a framework that strengthens credibility, risk management and business resilience.",
    ],
    sub1: "ESG Reporting & Disclosures",
    sub2: "Sustainability Strategy & Carbon Footprint Analysis",
    sub3: "CSR Compliance Advisory",
  },
  {
    Id: "10",
    category: "Advisory & Deals",
    icon: <FaUserTie />,
    image: img10,
    sTitle: "Virtual CFO Services",
    intro: "CFO-Level Financial Leadership — Without a Full-Time CFO",
    description: [
      "Growing businesses and multinational subsidiaries often need strategic financial leadership, but may not yet require or be ready for a full-time Chief Financial Officer.",
      "Our Virtual CFO Services provide exactly that — experienced financial leadership on a flexible basis backed by senior Chartered Accountant expertise.",
      "We partner with Boards, promoters and management teams to support strategic financial planning, performance oversight, governance and reporting — helping you make better decisions with confidence.",
    ],
    sub1: "Strategic Financial Leadership",
    sub2: "Business Performance Review",
    sub3: "Capital Allocation & Cash-Flow Planning",
    sub4: "Investor & Lender Reporting",
    sub5: "Board-Level Financial Advisory",
  },
];

export default servicesData;
